module.exports = __webpack_public_path__ + "static/img/5.4c4dc1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client_logo/5.jpg
// module id = 8nWI
// module chunks = 0